export default __webpack_public_path__ + "static/media/twitter.030e8f6f.svg";